// extracted by mini-css-extract-plugin
module.exports = {"password":"PasswordToggle-module__password___bDU2q"};